import React, { useState } from 'react';

import Footer from '../../components/Footer';

import Contact from '../../components/Contact';

const Contactpage = () => {


 return (
  <>
    <Contact />
    <Footer/>
    </>
  );
};

export default Contactpage;

